import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'view-edit-button',
  templateUrl: 'view-edit-button.component.html',
  styleUrls: ['view-edit-button.component.scss'],
})
export class ViewEditButtonComponent {
  @Input() isEditMode: boolean = false;
  @Input() isSaveMode: boolean = false;

  @Output() viewEditSaveClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();

  buttons: any = [
    {
      text: 'Edit',
      icon: 'pen-ribbonblue-icon',
      active: () => this.isEdit,
    },
    {
      text: 'View',
      icon: 'eye-white-icon',
      active: () => this.isView,
    },
    {
      text: 'Save',
      icon: 'check-mark-icon',
      active: () => this.isSaveMode,
    }
  ];

  get isEdit(): boolean {
    return this.isEditMode && !this.isSaveMode;
  }

  get isView(): boolean {
    return !this.isEditMode && !this.isSaveMode;
  }

  onBtnClick() {
    this.viewEditSaveClick.emit();
  }

  onCancelClick() {
    this.cancelClick.emit();
  }
}
